import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { PollService } from "../../polls/polls.service";
import { debounceTime, distinctUntilChanged, filter, mergeMap, of, Subject, takeUntil, tap } from "rxjs";
import { Poll } from "../../polls/polls.type";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import Delta from "quill-delta";
import { LinkPreview, RichTextComment } from "@teammood/timeline";
import { MoodsService } from "../../timeline/timeline-item/moods/moods.service";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
    selector: 'add-poll-comment',
    templateUrl: './add-poll-comment.component.html',
    styleUrls: ['./add-poll-comment.component.scss'],
    providers: [PollService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddPollCommentComponent implements OnInit, OnDestroy {

    protected poll: Poll;

    protected rtaContent: Delta;
    protected linkPreviews: LinkPreview[] = [];
    protected isFieldEmplty = true;

    private _destroy$ = new Subject<void>();

    constructor(
        private cdr: ChangeDetectorRef,
        private pollService: PollService,
        private snackBarService: SnackBarService,
        private translateService: TranslateService,
        private route: ActivatedRoute,
        private router: Router,
        private moodsService: MoodsService,
    ){}

    ngOnInit() {
        this.rtaContent = new Delta();

        this.route.params
            .pipe(
                filter(params => !!params['pollId']),
                mergeMap(params => {
                    return this.pollService.getPoll(params['pollId']).pipe(
                        tap(poll => {
                            this.poll = poll;
                        }),
                    )
                }),
                takeUntil(this._destroy$)
            ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    protected saveComment(){
        const comment = this.rtaContent;
        if (comment && !this.isFieldEmplty) {
            this.pollService.postUserCommentToPoll(this.poll.id, comment).pipe(
                tap(poll => {
                    if (poll.poll.error) {
                        this.snackBarService.error(this.translateService.instant(poll.poll.error));
                    } else {
                        this.snackBarService.success(this.translateService.instant('poll.comment.success'));
                        setTimeout(async () => {
                            await this.router.navigate(['add_other_feedback/poll', this.poll.publishedOn]);
                        }, 1000);
                    }
                })
            ).subscribe();
        }
    }

    protected async skipAddingComment(){
        await this.router.navigate(['add_other_feedback/poll', this.poll.publishedOn]);
    }

    protected onContentChange(update: Delta){
        of(update).pipe(
            debounceTime(500),
            distinctUntilChanged(),
            // filter(update => update.ops.filter(op => op.attributes?.link).length > 0), // any url? -> remove for restore update when removing content
            mergeMap(update => {
                return this.moodsService.getDeltaLinkPreviews(update).pipe(
                    tap(previews => {
                        this.linkPreviews = previews.filter(preview => preview.title && preview.description);
                    }),
                )
            }),
            takeUntil(this._destroy$),
        ).subscribe();

        this.rtaContent = update;
        this.isFieldEmplty = RichTextComment.isEmptyDelta(this.rtaContent);
        this.cdr.detectChanges(); // Force change detection
    }
}
